import React from 'react';
import { View } from 'react-native';
const SafeAreaSpacerView = ({
  style
}) => {
  return <View style={style} />;
};
SafeAreaSpacerView.displayName = 'IGNORE';
export default SafeAreaSpacerView;